import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  btn: {
    // width: 300,
    // lineHeight: "3em",
    //  borderRadius: 4,
    display: "block",
    textAlign: "center",
    // boxShadow: '0 0 12px #dddd',
    color: "#000",
    height: "100%",
    // padding: `${theme.spacing(4)}px ${theme.spacing(3)}px`,
    // height: 300,
    // transition: "0.2s",
    "& img, & svg": {
      marginTop: theme.spacing(1),
      marginBottom: 21,
      fontSize: 70,
      height: "1em",
      width: "1em"
    },
    "& h6": {
      lineHeight: 1.2,
      marginBottom: 10
    },
    "& p": {
      lineHeight: 1.2,
      marginBottom: 15
    }
    // "&:hover": {
    //   color: "#000 !important",
    //   boxShadow: "0 0 50px #dedede",
    // },
  },
  paper: {
    cursor: "pointer",
    height: "100%",
    "&:hover": {
      boxShadow: "0 4px 16px rgba(117,118,126,0.3)"
    }
  },
  wordBreak: {
    wordWrap: "break-word",
    overflow: "hidden"
  },
  root: {
    display: "inline-block",
    color: "inherit",
    lineHeight: 0,
    textAlign: "center",
    verticalAlign: "0.5em",
    userSelect: "none",
    textTransform: "none",
    textRendering: "optimizelegibility",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
  }
}));

export default useStyles;
